import React, { useState } from 'react'

import { Tab, Tabs, Tooltip, useTheme } from '@material-ui/core'
import FormatPaintIcon from '@material-ui/icons/FormatPaint'

import { Container } from '../../components'
import { PagePropertyGrade } from '../PortfolioAnalytics/components'
import { ReactComponent as ListSBIcon } from '../../assets/icons/action-item.svg'
import { AssignmentIndOutlined } from '@material-ui/icons'
import { BorderTop } from '@material-ui/icons'
import { ProjectsTab } from './Projects/ProjectsTab'
import { ActionItemPage } from './ActionItemPage'
import { WorkorderType } from '../../models'
import { WorkorderContext, useWorkorderState } from '../../contexts'

const BIPS_TAB = 0
const SERVICE_REQUEST_TAB = 1
const ACTION_ITEM_TAB = 2
const SERVICE_ORDER_TAB = 3

export const OrganizationFacilitiesHome = () => {
    const [selectedTab, setSelectedTab] = useState<number>(BIPS_TAB)
    const workorderState = useWorkorderState()
    const theme = useTheme()

    return (
        <WorkorderContext.Provider value={workorderState}>
            <Container
                style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Tabs
                    style={{
                        width: '100%',
                        backgroundColor: theme.palette.grey[300],
                    }}
                    value={selectedTab}
                    onChange={(_, v) => {
                        if (v !== selectedTab) {
                            setSelectedTab(v)
                        }
                    }}
                >
                    <Tooltip title="Building - Inspector Performance Score">
                        <Tab
                            label={
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                    }}
                                >
                                    <BorderTop />
                                    BIPS
                                </div>
                            }
                            style={{ textTransform: 'none' }}
                        />
                    </Tooltip>
                    <Tooltip title="Service Requests">
                        <Tab
                            label={
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                    }}
                                >
                                    <AssignmentIndOutlined />
                                    Service Requests
                                </div>
                            }
                            style={{ textTransform: 'none' }}
                        />
                    </Tooltip>
                    <Tooltip title="Action Items">
                        <Tab
                            label={
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                    }}
                                >
                                    <ListSBIcon
                                        style={{ height: 20, width: 20 }}
                                    />
                                    Action Items
                                </div>
                            }
                            style={{ textTransform: 'none' }}
                        />
                    </Tooltip>
                    <Tooltip title="Projects">
                        <Tab
                            label={
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                    }}
                                >
                                    <FormatPaintIcon />
                                    Projects
                                </div>
                            }
                            style={{ textTransform: 'none' }}
                        />
                    </Tooltip>
                </Tabs>

                {selectedTab === BIPS_TAB && (
                    <PagePropertyGrade theme={theme} ezFolio />
                )}
                {selectedTab === SERVICE_REQUEST_TAB && (
                    <ActionItemPage
                        workorderType={WorkorderType.SERVICE_REQUEST}
                    />
                )}
                {selectedTab === ACTION_ITEM_TAB && (
                    <ActionItemPage workorderType={WorkorderType.ACTION_ITEM} />
                )}
                {selectedTab === SERVICE_ORDER_TAB && <ProjectsTab />}
            </Container>
        </WorkorderContext.Provider>
    )
}
